import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useAuth0 } from "@auth0/auth0-react";
import * as selectors from "domain/core/selector";
import { useActions, useReduxState } from "re-reduced";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import AppBarComponent from "ui/compounds/AppBar/AppBarComponent";
import Footer from "../Footer";
import AuthActions from "domain/core/auth/actions";
import Home from "../Home";
import Dashboard from "../Dashboard";
import Workshops from "../Workshops";
import Content from "../Content";
import Assessment from "../Assessment";
import { ROUTES } from "../routes";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    maxWidth: "1920px",
    margin: "auto",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.default,
    overscrollBehavior: "none", // disables pull-to-refresh
  },
}));
const AuthenticatedHome = () => {
  const classes = useStyles();

  return (
    <Router>
      <div className={classes.root}>
        <Switch>
          <Route path={ROUTES.home}>
            <AppBarComponent changeOnScroll={true} />
            <Home />
          </Route>
          <Route path={ROUTES.dashboard}>
            <AppBarComponent changeOnScroll={true} />
            <Dashboard />
          </Route>
          <Route path={ROUTES.assessment}>
            <AppBarComponent changeOnScroll={false} />
            <Assessment />
          </Route>
          <Route path={ROUTES.workshops}>
            <AppBarComponent changeOnScroll={true} />
            <Workshops />
          </Route>
          <Route path={ROUTES.learn}>
            <AppBarComponent changeOnScroll={true} />
            <Content />
          </Route>
          <Route path={ROUTES.dashboard}>
            <AppBarComponent changeOnScroll={true} />
            <Dashboard />
          </Route>
          <Route path="/">
            <AppBarComponent changeOnScroll={true} />
            <Dashboard />
          </Route>
        </Switch>
        <Footer />
      </div>
    </Router>
  );
};

export default AuthenticatedHome;
